import React from "react"

import { BabyButton, GradientButton } from "@housebets/housebets-x-package";
import { HeaderCenterWrapper } from "@housebets/housebets-x-package/lib/components/layout/Layout";
import { CryptoDropdown, RewardDropdown } from "app/components/features";

import { setWalletType } from "app/store/slices/setting";
import { WalletType } from "app/types/common";

import { useCurrencyToolbarData } from "./hooks/useCurrencyToolbarData";
import { useDispatch } from "react-redux";
import { useIntl } from "react-intl";

export const CurrencyToolbar: React.FC = () => {
    const { isAuth, isMobile, isTablet } = useCurrencyToolbarData()
    const dispatch = useDispatch();
    const { $t } = useIntl();

    return <HeaderCenterWrapper>
        {isAuth && (
            <>
                <CryptoDropdown />
                {!isMobile && !isTablet && (
                    <GradientButton
                        text={$t({id: "Deposit"})}
                        kind="fill2"
                        size="md-2"
                        onClick={() => {
                            dispatch(setWalletType(WalletType.Deposit))
                        }}
                    />
                )}
                {(isMobile || isTablet) && (
                    <BabyButton.Wallet
                        title={$t({id: "Deposit"})}
                        isActive
                        kind={isMobile || isTablet ? 'transparent' : 'green'}
                        size={isMobile || isTablet ? 'sm' : 'md'}
                        onClick={() => {
                            dispatch(setWalletType(WalletType.Deposit))
                        }}
                    />
                )}
                <RewardDropdown />
            </>
        )}
    </HeaderCenterWrapper>
}

CurrencyToolbar.displayName = 'Toolbar.CurrencyToolbar';